import { render, staticRenderFns } from "./metric.vue?vue&type=template&id=0ab060d4&scoped=true&"
import script from "./metric.vue?vue&type=script&lang=js&"
export * from "./metric.vue?vue&type=script&lang=js&"
import style0 from "./metric.vue?vue&type=style&index=0&id=0ab060d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab060d4",
  null
  
)

export default component.exports